import { render, staticRenderFns } from "./participant-dashboards.vue?vue&type=template&id=347db663&scoped=true&"
import script from "./participant-dashboards.vue?vue&type=script&lang=js&"
export * from "./participant-dashboards.vue?vue&type=script&lang=js&"
import style0 from "./participant-dashboards.vue?vue&type=style&index=0&id=347db663&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "347db663",
  null
  
)

component.options.__file = "participant-dashboards.vue"
export default component.exports